import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SampleReview from "./pages/SampleReview";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sample" element={<SampleReview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
